import { render, staticRenderFns } from "./repairDetailResource.vue?vue&type=template&id=70885994"
import script from "./repairDetailResource.vue?vue&type=script&lang=js"
export * from "./repairDetailResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports